import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/request'
import { socketUrl } from '@/request/config'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: {},
    countryList: [],
    stockExchangesList: [],
    unread_number: 0,
    /** @type {WebSocket|null} */
    socketTask: null,
    socketList: []
  },

  mutations: {
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_COUNTRYLIST(state, countryList) {
      state.countryList = countryList
    },
    SET_EXCHANGESLIST(state, stockExchangesList) {
      state.stockExchangesList = stockExchangesList
    }
  },

  actions: {
    // ── WebSocket ─────────────────────────────────────────────────────────────
    clearnSocket({ state }) {
      if (state.socketTask) {
        try { state.socketTask.close() } catch (e) { /* ignore */ }
        state.socketTask = null
      }
    },

    openSocket({ state }) {
      if (state.socketTask) return

      const _socketUrl =
        process.env.NODE_ENV === 'development'
          ? socketUrl
          : `wss://${window.location.host}${socketUrl}`

      const ws = new WebSocket(_socketUrl)

      ws.onopen = () => {
        state.socketTask = ws
      }

      ws.onmessage = (e) => {
        try {
          const parsed = typeof e.data === 'string' ? JSON.parse(e.data) : e.data
          state.socketList = parsed.data || parsed
        } catch { /* ignore */ }
      }

      ws.onclose = () => {
        state.socketTask = null
      }

      ws.onerror = () => {
        state.socketTask = null
      }

      // 保存引用（onopen 前也需要能访问）
      state.socketTask = ws
    },

    // ── 登录检查 & Socket 认证 ────────────────────────────────────────────────
    async startLoginCheck({ dispatch, state }) {
      const localUserInfo = localStorage.getItem('userInfo')
      if (localUserInfo) {
        await dispatch('getUserInfo')
      }
      if (!state.socketTask) {
        await dispatch('openSocket')
      }

      const sendAuth = () => {
        if (state.userInfo && state.userInfo.uid && state.socketTask &&
            state.socketTask.readyState === WebSocket.OPEN) {
          state.socketTask.send(JSON.stringify({
            type: 'auth',
            member_id: state.userInfo.uid
          }))
        }
      }

      sendAuth()
      setInterval(async () => {
        if (localStorage.getItem('userInfo')) {
          await dispatch('getUserInfo')
        }
        if (!state.socketTask) {
          await dispatch('openSocket')
        }
        sendAuth()
      }, 2000)
    },

    // ── 用户信息 ──────────────────────────────────────────────────────────────
    async unreadNumber({ state }) {
      try {
        const { data } = await api.unreadNumber()
        state.unread_number = data.unread_number
      } catch (e) { /* ignore */ }
    },

    async getUserInfo({ state, commit }) {
      try {
        if (JSON.stringify(state.userInfo) === '{}') {
          const { data } = await api.getuserinfo()
          localStorage.setItem('userInfo', JSON.stringify(data))
          commit('SET_USERINFO', data)
        }
      } catch (e) { /* ignore */ }
    },

    async resetGetUserInfo({ commit }) {
      try {
        const { data } = await api.getuserinfo()
        localStorage.setItem('userInfo', JSON.stringify(data))
        commit('SET_USERINFO', data)
      } catch (e) { /* ignore */ }
    },

    async getStockExchanges({ state, commit }) {
      try {
        if (state.stockExchangesList.length > 1) return
        const list = [{ name: uni.$i18n.t('所有'), id: 0 }]
        const { data } = await api.getStockExchanges()
        data.forEach(item => list.push({ name: item.name, id: item.id }))
        commit('SET_EXCHANGESLIST', list)
      } catch (e) {
        console.log(e)
      }
    },

    async getNationOptions({ state, commit }) {
      if (state.countryList.length > 1) return
      const list = [{ name: uni.$i18n.t('所有'), id: 0 }]
      const { data } = await api.getNationOptions()
      data.forEach(item =>
        list.push({
          name: uni.$i18n.t(`${item.name}`),
          id: item.id,
          lange_code: item.lange_code,
          phone_code: item.phone_code
        })
      )
      commit('SET_COUNTRYLIST', list)
    }
  }
})

export default store

